import React, { useRef, useEffect, useLayoutEffect, useContext, useState, } from 'react';
import * as ReactDOM from 'react-dom';
import cn from 'classnames';
import { Icons } from '@beeline/design-tokens/js/iconfont/icons';
import { useBEM, PopupsContext } from '../../../../../../utils';
import { Button } from '../../../../../Button';
import { NavigationIcon } from '../../../navigation-icon';
import "./styles.css";
var _a = useBEM('lk-ui_calendar-mobile'), calendarClassName = _a[0], calendarModifier = _a[1], calendarBlockModifier = _a[2];
var footerClassName = calendarBlockModifier('footer')[0];
var _b = calendarBlockModifier('header'), headerClassName = _b[0], headerModifier = _b[1];
export var CalendarMobileContext = React.createContext({});
export var CalendarMobileView = function (_a) {
    var className = _a.className, datepickerRef = _a.datepickerRef, onOutsideClick = _a.onOutsideClick, onClickSelectDates = _a.onClickSelectDates, _b = _a.dataTestId, dataTestId = _b === void 0 ? 'calendar' : _b, saveButtonTitle = _a.saveButtonTitle, children = _a.children, viewYear = _a.viewYear, readonly = _a.readonly;
    var calendarRef = useRef(null);
    var _c = useState(), rootElement = _c[0], setRootElement = _c[1];
    var _d = useContext(CalendarMobileContext), applicationElementID = _d.applicationElementID, calendarElementID = _d.calendarElementID, rootElementCntx = _d.rootElement;
    var _e = useContext(PopupsContext), baseAppElementID = _e.applicationElementID, rootElementDefaultCntx = _e.rootElement;
    var applicationRootElementId = applicationElementID || baseAppElementID || 'root';
    var elementID = calendarElementID || 'calendar-mobile';
    var element = rootElementCntx || rootElementDefaultCntx;
    useEffect(function () {
        var handleOutsideClick = function (event) {
            var targetElement = event === null || event === void 0 ? void 0 : event.target;
            var calendarElement = calendarRef === null || calendarRef === void 0 ? void 0 : calendarRef.current;
            var datepickerElement = datepickerRef === null || datepickerRef === void 0 ? void 0 : datepickerRef.current;
            var isOutsideClick = ![datepickerElement, calendarElement].some(function (element) { return element && element.contains(targetElement); });
            if (isOutsideClick) {
                onOutsideClick === null || onOutsideClick === void 0 ? void 0 : onOutsideClick();
            }
        };
        var listenerContainer = element || window;
        listenerContainer.addEventListener('mousedown', handleOutsideClick);
        return function () { return listenerContainer.removeEventListener('mousedown', handleOutsideClick); };
    }, []);
    var createPortalRoot = function (rootId) {
        var rootElement = document.createElement('div');
        rootElement.id = rootId;
        rootElement.className = calendarModifier('wrapper');
        return rootElement;
    };
    useLayoutEffect(function () {
        var mount = element || document.getElementById(applicationRootElementId);
        if (!mount)
            throw new Error("Application root element with ID \"" + applicationRootElementId + "\" not found");
        var el = createPortalRoot(elementID);
        var elementRef = mount.appendChild(el);
        setRootElement(elementRef);
        return function () {
            mount.removeChild(el);
        };
    }, [applicationRootElementId, elementID, element]);
    var calendarContent = (React.createElement("div", { ref: calendarRef, className: cn(calendarClassName, className), "data-test-id": dataTestId },
        React.createElement("header", { className: headerClassName },
            React.createElement(NavigationIcon, { direction: Icons.NavArrowLeft, onClick: onOutsideClick ? onOutsideClick : function () { }, dataTestId: dataTestId + "-back" }),
            React.createElement("span", { className: headerModifier('title'), "data-test-id": dataTestId + "-select-year" }, viewYear)),
        children,
        !readonly && (React.createElement("div", { className: footerClassName },
            React.createElement(Button, { variant: 'contained', onClick: onClickSelectDates, size: 'medium' }, saveButtonTitle || 'Сохранить')))));
    return ((rootElement && ReactDOM.createPortal(calendarContent, rootElement)) || null);
};
